module.exports = __webpack_public_path__ + "e4854fc0faf7f2e5819691b970180461.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_psp_2022_chart.png
// module id = 1659
// module chunks = 0